import { render, staticRenderFns } from "./SmsTemplateAdd.vue?vue&type=template&id=e8769c3c&scoped=true&"
import script from "./SmsTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./SmsTemplateAdd.vue?vue&type=style&index=0&id=e8769c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8769c3c",
  null
  
)

export default component.exports